import { render, staticRenderFns } from "./OrderCourseOverrides.vue?vue&type=template&id=1f920613&scoped=true&"
import script from "./OrderCourseOverrides.vue?vue&type=script&lang=js&"
export * from "./OrderCourseOverrides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f920613",
  null
  
)

export default component.exports